const defaultBannerTout = [
  {
    slot: {
      '0': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: `${process.env.PUBLIC_URL}/content/images/banners/default/banner/MobilePortrait.jpg`,
          hasWebp: false,
          classes: 'bgp-c'
        }
      },
      '425': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: `${process.env.PUBLIC_URL}/content/images/banners/default/banner/MobileLandscape.jpg`,
          hasWebp: false,
          classes: 'bgp-c'
        }
      },
      '1024': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: `${process.env.PUBLIC_URL}/content/images/banners/default/banner/Desktop.jpg`,
          hasWebp: false,
          classes: 'bgp-b'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'ctt',
        classes: '',
        content: {
          type: 'spacer',
          space: '0rem'
        }
      },
      '665': {
        area: 'ctt',
        classes: '',
        content: {
          type: 'spacer',
          space: '2rem'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'ct',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'text',
          textlines: [
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-m lh-120 ta-c mt-1'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-m lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-m lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-m lh-120 ta-c'
            }
          ]
        }
      },
      '665': {
        area: 'ct',
        classes: 'w-1/1 w-24rem  mtn+',
        content: {
          type: 'text',
          textlines: [
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-t lh-120 ta-c mt-1'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-t lh-120 ta-c'
            }
          ]
        }
      },
      '768': {
        area: 'ct',
        classes: 'w-1/1 maw-36rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-t lh-120 ta-c mt-1'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-t lh-120 ta-c'
            }
          ]
        }
      },
      '1170': {
        area: 'ct',
        classes: 'w-1/1 w-39rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-d lh-120 ta-c mt-1'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-d lh-120 ta-c'
            }
          ]
        }
      },
      '1440': {
        area: 'ct',
        classes: 'w-1/1 maw-41rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-d lh-120 ta-c mt-1'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: 'ㅤ',
              classes: 'c-janet fw-600 fz-body-d lh-120 ta-c'
            }
          ]
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'cb',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'text',
          textlines: [
            {
              text: '',
              classes: 'p0 c-janet fz-legal-m lh-120 ta-c'
            },
            {
              text: '',
              classes: 'p0 c-janet fz-legal-m lh-120 ta-c'
            },
            {
              text: '',
              classes: 'p0 c-janet fz-legal-m lh-120 ta-c'
            },
            {
              text: '',
              classes: 'p0 c-janet fz-legal-m lh-120 ta-c'
            }
          ]
        }
      },
      '665': {
        area: 'cb',
        classes: 'w-1/1 w-24rem  mtn+',
        content: {
          type: 'text',
          textlines: [
            {
              text: '',
              classes: 'c-janet  fz-legal-t lh-120 ta-c mt-3'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-t lh-120 ta-c'
            }
          ]
        }
      },
      '768': {
        area: 'cb',
        classes: 'w-1/1 maw-36rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '',
              classes: 'c-janet  fz-legal-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-t lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-t lh-120 ta-c'
            }
          ]
        }
      },
      '1170': {
        area: 'cb',
        classes: 'w-1/1 w-39rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '',
              classes: 'c-janet  fz-legal-d lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-d lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-d lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-d lh-120 ta-c'
            }
          ]
        }
      },
      '1440': {
        area: 'cb',
        classes: 'w-1/1 maw-41rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '',
              classes: 'c-janet  fz-legal-d lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-d lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-d lh-120 ta-c'
            },
            {
              text: '',
              classes: 'c-janet  fz-legal-d lh-120 ta-c'
            }
          ]
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'cbb',
        classes: '',
        content: {
          type: 'spacer',
          space: '0rem'
        }
      },
      '665': {
        area: 'cbb',
        classes: '',
        content: {
          type: 'spacer',
          space: '2rem'
        }
      }
    }
  }
]

export default defaultBannerTout
